import { render, staticRenderFns } from "./ArticleSource.vue?vue&type=template&id=0bc8fb1c"
import script from "./ArticleSource.vue?vue&type=script&lang=ts"
export * from "./ArticleSource.vue?vue&type=script&lang=ts"
import style0 from "./ArticleSource.vue?vue&type=style&index=0&id=0bc8fb1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports